import React, { useEffect, useState } from "react";
import {
  BackButton,
  CancelButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import {
  NuDate,
  NuInput,
  NuTextArea,
} from "../../../../Components/Utils/Input";
import { useFormik } from "formik";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import * as yup from "yup";
import useEditFormData from "../../../../Components/Hooks/useEditFormData";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import Pdf from "../../../../Components/Icons/Pdf";
import Txt from "../../../../Components/Icons/Txt";
import Xls from "../../../../Components/Icons/Xls";
import Doc from "../../../../Components/Icons/Doc";
import Video from "../../../../Components/Icons/Video";
import Attachement, {
  videotype,
} from "../../../../Components/Utils/CustomAttrachmentupload";
import CloseIcon from "../../../../Components/Icons/Close";
import DropDownAddMetaData from "../../../../Components/Utils/selectAddMetaData";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import UseDropDown from "../../../../Components/Hooks/useDropDown";
import UseCustomerDropDownNew from "../../../../Components/Hooks/useCustomerSearch";
import { useToast } from "../../../../Components/Others/ToastServices";
import MultiSelect from "../../../../Components/Utils/MultiSelect";
import axiosInstance from "../../../../Services/axiosCommon";
import { SettingHeading } from "../../../../Components/Utils/Settingheading";

const filetype = [
  "docx",
  "doc",
  "xlsx",
  "xls",
  "pdf",
  "txt",
  "pptx",
  "mp4",
  "mov",
  "wmv",
  "avi",
  "flv",
  "mkv",
];

function EditSupportTickets() {
  const { supportTickEditId } = useParams();
  const navigate = useNavigate();

  const toast = useToast();

  const [image, setImage] = useState([]);

  const [selectedFile, setSelectedFile] = useState(null);
  const [filePathList, setFilePathList] = useState([]);
  const [fileRemoveList, setFileRemoveList] = useState([]);
  const [removefilePathList, setRemoveFilePathList] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [fileExtention, setFileExtention] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const location = useLocation();
  const data = location.state?.data;

  const from = location.state?.from;

  const [searchClient, setSearchClient] = useState("");

  const { data: user } = UseDropDown(`/user/new-drop-down`);
  const { data: copy } = UseDropDown(`/user/new-drop-down`);

  const { data: client, setDataCustomer } = UseCustomerDropDownNew(
    "/clients/drop-down",
    searchClient
  );

  const { data: contract } = UseDropDown(`/contract/drop-down`);

  const { value: TicketType, getData: refTicketType } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Ticket_Type"
  );

  const { value: Priority, getData: refPriority } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "priority"
  );

  const { value: Status, getData: refStatus } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Status_Support_Tickets"
  );

  const { value: Division, getData: refDivision } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Division_Support_Tickets"
  );

  const { value: Category, getData: refCategory } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Category_Support_Tickets"
  );
const [createNew, setCreateNew] = useState([]);
  const { editFormData ,isLoading} = useEditFormData();
    function getView() {
      axiosInstance
        .get(`/tickets/ticket-details/${supportTickEditId}`)
        .then((res) => {
          console.log(res,'response');
  setCreateNew({
    startDate: data?.startDate || "",
    endDate: data?.endDate || "",
    category: data?.category || "",
    responseDate: data?.responseDate || "",
    division: data?.division || "",
    priority: data?.priority || "",
    refNumber:data?.refNumber || "",
      status:res?.data?.data?.status || "",

    
    assignedTo: Array.from(new Set(data?.assignees?.assignedTo?.map(item => item.id))) || [],
    copyTo: Array.from(new Set(data?.assignees?.copyTo?.map(item => item.id))) || [],
      filesToRemove: [],
  });
  })
  .catch((err) => {
    console.log("err", err);
  });
  }
   useEffect(() => {
      // if (!cData) {
      getView();
      console.log(createNew,"createnew");
      
      // }
    }, []);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      assignedTo: yup.array().required("Assigned To is required!"),
    }),
    onSubmit: async (value, { resetForm }) => {
      let formData = new FormData();
      const valueWithProducts = {
        ...value,
        assignedTo: Array.from(new Set(value.assignedTo)),
  copyTo: Array.from(new Set(value.copyTo)),

        filesToRemove: fileRemoveList,
      };
      formData.append("json_data", JSON.stringify(valueWithProducts));
      // formData.append("attachments", image.raw);
      if (selectedFile !== null) {
        selectedFile.forEach((file) => {
          formData.append("attachments", file);
        });
      } else {
        formData.append("attachments", []);
      }
                           await editFormData({url:`/tickets/assign-ticket/${supportTickEditId}`,formData:formData,navigateUrl:from ||`/tickets/support-tickets`,resetForm:resetForm   })

      // editFormData(
      //   `/tickets/assign-ticket/${supportTickEditId}`,
      //   formData,
      //   resetForm,
      //   from
      // );
    },
  });



 function handleImageChange(e) {
    const maxFileSize = 200000000; // 200 MB
    const files = Array.from(e.target.files);
    let fileArr = [];

    files.forEach((item) => {
      if (item.size < maxFileSize) {  
        fileArr.push(item);
      } else {
        toast.open({
          type: "warning",
          message: `File Size too big`,
          description: `${item.name} is removed and not uploaded`,
        });
      }
    });

    setSelectedFile(fileArr);


    setImage(fileArr);
    e.target.value = null;
  }

  const removeImages = (value) => {
    let List = selectedFile.filter((item) => item?.name !== value?.name);
    setSelectedFile([...List]);
    setImage(List);
  };

  useEffect(() => {
    if (
      data?.attachments !== null &&
      data?.attachments !== "None" &&
      data?.attachments !== "[]"
    ) {
      console.log(data?.attachments, "ghjkllgd");
      setFilePathList(data?.attachments);

      setRemoveFilePathList(data?.attachments);
    }
  }, [data]);

  function UpdateAttachmentList(item) {
    let filterList = filePathList.filter((itemList) => itemList.file !== item);
    let removeFile = filePathList.find((itemList) => itemList.file === item);
    console.log("llll", filterList);
    setFileRemoveList([...fileRemoveList, removeFile.file]);
    setFilePathList(filterList);
  }

  function handleImageClick(img) {
    let Ext = img?.file_name.split(".").reverse()[0];
    setSelectedImage(img);
    setFileExtention(Ext);
    setIsModalOpen(true);
  }

  return (
    <div className=" w-full h-full py-2 px-4 ">
      <div className="flex justify-between w-full ">
        <Breadcrumb
          items={[
            // { name: "Testing&Commissioning" },
            { name: "Support-Tickets", link: "/tickets/support-tickets" },
            { name: "Edit" },
          ]}
        />
        <BackButton />
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="w-full mx-auto h-[calc(100vh-145px)] bg-white rounded-xl overflow-hidden mt-4">
          <div className=" w-full h-full flex justify-start content-start flex-wrap py-2 px-4  overflow-y-auto">
            <div className="w-full">
                                    <SettingHeading title={`Support Ticket : ${createNew?.refNumber}` } />
              
            </div>

            <MultiSelect
              label="Assigned To"
              Options={user}
              formik={formik}
              placeholder="Choose"
              name="assignedTo"
              isRequired={true}
              width="w-full md:w-1/3 md:-mt-2"
            />

            <MultiSelect
              label="Copy to"
              Options={copy}
              formik={formik}
              placeholder="Choose"
              name="copyTo"
              isRequired={true}
              width="w-full md:w-1/3 md:-mt-2"
            />
            <NuDate
              label="Response Date"
              placeholder="Response Date"
              formik={formik}
              name="responseDate"
              width="w-full md:w-1/3 md:-mt-2"
            />

              {/* <NuDate
              label="Start Date"
              placeholder="Start Date"
              formik={formik}
              name="startDate"
              width="w-full md:w-1/3 md:-mt-2"
              min={new Date().toISOString().split("T")[0]} // today
            /> */}

            <NuDate
              label="Start Date"
              placeholder="Start Date"
              formik={formik}
              name="startDate"
              width="w-full md:w-1/3 md:-mt-2"
              min={
                formik.initialValues.startDate
                  ? new Date(formik.initialValues.startDate).toISOString().split("T")[0]
                  : new Date().toISOString().split("T")[0]
              }
            />
            
            <NuDate
              label="End Date"
              placeholder="End Date"
              formik={formik}
              name="endDate"
              width="w-full md:w-1/3 md:-mt-2"
              min={formik.values.startDate || new Date().toISOString().split("T")[0]}
              disabled={!formik.values.startDate}
            />

            <FormikSelectTwo
              label="Priority"
              Options={Priority}
              formik={formik}
              placeholder="Choose"
              name="priority"
              width="w-full md:w-1/3 "
              displayProperty={"Priority"}
              propertyName={"priority"}
              getFunc={refPriority}
            />

            <FormikSelectTwo
              label="Division"
              Options={Division}
              formik={formik}
              placeholder="Choose"
              name="division"
              width="w-full md:w-1/3 "
              displayProperty={"Division"}
              propertyName={"Division_Support_Tickets"}
              getFunc={refDivision}
            />

            <FormikSelectTwo
              label="Category"
              Options={Category}
              formik={formik}
              placeholder="Choose"
              name="category"
              width="w-full md:w-1/3 "
              displayProperty={"Category"}
              propertyName={"Category_Support_Tickets"}
              getFunc={refCategory}
            />
            <DropDownAddMetaData
              label="Status"
              Options={Status}
              formik={formik}
              placeholder="Choose"
              name="status"
              width="w-full md:w-1/3 md:-mt-1"
              displayProperty={"Status"}
              propertyName={"Status_Support_Tickets"}
              getFunc={refStatus}
            />

            <div className="w-full">
                         <SettingHeading title="Attachments"  />

              <Attachement
                handleChange={handleImageChange}
                preview={image || ""}
                width="w-full md:w-1/2"
                label="Attach"
                multiple={true}
                removeImages={removeImages}
              />
            </div>
            <div className="md:flex justify-between mt-5 px-3 w-full">
              <div className="w-full flex gap-2 items-center flex-wrap">
                {data?.attachments &&
                  filePathList?.map((imgs, idx) => {
                    console.log("img", imgs);
                    let Ext = imgs?.file_name.split(".").reverse()[0];
                    return (
                      <div
                        className=" w-20 h-9 my-2 relative flex justify-center items-center rounded-lg"
                        key={idx}
                        style={{
                          border: "1px solid gray",
                          borderColor:
                            "rgb(148 163 184 / var(--tw-bg-opacity))",
                        }}
                      >
                        <div
                          className=" w-4 h-4 rounded bg-slate-400 absolute text-white cursor-pointer font-medium flex justify-center items-center  -top-2 -right-2 z-10"
                          onClick={() => UpdateAttachmentList(imgs?.file)}
                        >
                          <CloseIcon color="white" height="8" width="8" />
                        </div>
                        <div
                          className=" w-20 h-9 flex justify-center items-center rounded-lg overflow-hidden cursor-pointer"
                          onClick={() => handleImageClick(imgs)}
                        >
                          <div className=" w-8 h-8">
                            {videotype.includes(Ext) ? <Video /> : null}

                            {Ext === ("docx" || "doc" || "txt") ? (
                              <Doc />
                            ) : Ext === ("xlsx" || "xls") ? (
                              <Xls />
                            ) : Ext === "txt" ? (
                              <Txt />
                            ) : Ext === "pdf" ? (
                              <Pdf />
                            ) : Ext === "PDF" ? (
                              <Pdf />
                            ) : Ext === "pptx" ? (
                              <>No file</>
                            ) : (
                              <img src={imgs?.file} alt="#" width="120%" />
                            )}
                          </div>
                          <p className=" w-[50px] text-[11px] truncate">
                            {imgs?.file_name}
                          </p>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>

            <div className="w-full  my-4 mt-8 ">
              <div className=" flex justify-end gap-4">
                <CancelButton
                  handleClick={() => {
                    navigate(-1);
                  }}
                />
                <SubmitButton isLoading={isLoading}/>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default EditSupportTickets;
